import { Card, Space, Tag, Typography } from "antd";
import type { FC } from "react";
import styles from "./style.module.css";
import { IBlog } from "api/blog";
import { getImageUrl } from "utils/urlParser";
import { Link } from "react-router-dom";
import { routesEnum } from "pages/Routes";

interface Props {
  data: IBlog;
}

const BigBlogCard: FC<Props> = ({ data }) => {
  return (
    <Link to={`${routesEnum.blog}/${data._id}`}>
      <Card hoverable className={styles.big_card} bodyStyle={{ padding: 0 }}>
        <Space size={56}>
          <div className={styles.big_card_cover}>
            <img
              alt={data.coverImage}
              src={getImageUrl(data.coverImage)}
              className={styles.big_card_cover}
            />
          </div>
          <div style={{ height: "100%" }}>
            <div>
              {Array.isArray(data.detail_categories) &&
                data.detail_categories.map((category) => (
                  <Tag key={category._id}>{category.name}</Tag>
                ))}
            </div>
            <Typography.Title
              level={2}
              ellipsis={{ rows: 2, expandable: false }}
            >
              {data.title}
            </Typography.Title>
            <Typography.Paragraph
              ellipsis={{ rows: 8, expandable: true, symbol: "more" }}
            >
              {data.description}
            </Typography.Paragraph>
            <button className={styles.read_more}>Read More</button>
          </div>
        </Space>
      </Card>
    </Link>
  );
};

export default BigBlogCard;
